export const darkTheme = {
    palette: {
        mode: 'dark', // Switching the dark mode on is a single property value change.
    },
};

export const lightTheme = {
    palette: {
        secondary: {
            light: '#FF6E2A',
            main: '#FF6E2A',
            dark: '#001064',
            contrastText: '#fff',
        },
    },
};
